/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { GlobalCacheKeys } from "../cache/globalCacheKeys";
import { UserContext } from "../ServiceWrapper";
import LoginPage from "./login";

interface CancelPageProps {
    /*hasAccessToken: Boolean,
    isAuthenticated: Boolean*/
}
const CancelPage: React.FC<CancelPageProps> = ({ }: CancelPageProps) => {
    const navigate = useNavigate();
    const [navPath, setNavPath] = useState<string>('');
    const { globalCache} = useContext(UserContext);
    

    useEffect(() => {

      let lastVisited = globalCache.getItem(GlobalCacheKeys.LAST_VISITED_PAGE);

      if (lastVisited !== null) {
        console.log('last visited: ' + lastVisited);
        setNavPath(lastVisited);
        globalCache.removeItem(GlobalCacheKeys.LAST_VISITED_PAGE);
      }
      else
      setNavPath('/');
    },[]);

    useEffect(() => {
      if (navPath != '') {
        console.log('navpath was set - navigating: ' + navPath);
        navigate(navPath);
      }
    }, [navPath]);

    
  return (
      <></>
  );
};

export default CancelPage;